<script>
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { pmfilters } from "lib/stores.js";
  import { getApplicableFilters } from "../../../../lib/util/getApplicableFilters";
  import { useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  // ui-elements
  import { Loading } from "carbon-components-svelte";
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import LineChartNeu from "lib/components/LineChartNeu.svelte";

  import Filter from "./components/filter/Filter.svelte";
  import FilterToast from "./components/FilterToast.svelte";

  // sidenav
  import { Accordion, SectionWrapper, Button } from "paxray-components-svelte";
  import AppSelection from "./components/appSelection.svelte";
  import AppInformation from "./components/appInformation.svelte";
  import Header from "lib/components/Header.svelte";
  import TimeOverview from "./components/TimeOverview.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import {
    ARROW_LEFT_ICON,
    FULLSCREEN_ICON,
    FULLSCREEN_OFF_ICON,
    SQUARE_LANDSCAPE_ICON,
  } from "@utils/icons.js";

  export let analysisid;
  const navigate = useNavigate();
  const { setCurrentView } = filtersConfigStore;

  let currentApp = "";
  let windowPartitionsLoading = false;

  let applicationlist = [];
  let windowlist = [];
  let fullscreen = false;
  let selectedLevel = 0;
  let selectedIndex = 0;
  let usersSelected = false;
  let dailySelected = 0;
  let casesSelected = false;
  let view = "Workloads";
  let showToast = false;
  let tabOptions = ["Interactions", "Users", "Cases"];

  let loading = false;
  let data = { time: [], keystrokes: [], mouseclicks: [] };

  let lineChart;
  let TimeOverviewChart;

  $: setCurrentView(view, tabOptions[selectedIndex]);

  $: {
    if (!casesSelected)
      AppOverviewTimeKPIs(
        currentApp,
        selectedLevel,
        $pmfilters,
        $filtersConfigStore.storeLoaded,
      );
  }

  $: if (
    $pmfilters[analysisid] &&
    $filtersConfigStore.storeLoaded &&
    !casesSelected
  ) {
    getWindowPartitions();
  }

  $: {
    if (selectedIndex === 1) {
      usersSelected = true;
      casesSelected = false;
      dailySelected = 0;
    } else if (selectedIndex === 2) {
      usersSelected = false;
      casesSelected = true;
      dailySelected = 1;
    } else {
      usersSelected = false;
      casesSelected = false;
      dailySelected = 0;
    }
  }

  function getWindowPartitions() {
    windowPartitionsLoading = true;
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/getWindowPartitions?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        windowlist = data;
        windowPartitionsLoading = false;
      });
    fetchWithSession(
      `/api/analysis/AppOverviewKPIs?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        applicationlist = data;
        windowPartitionsLoading = false;
      });
  }

  currentApp = "";

  function AppOverviewTimeKPIs(
    applicationname,
    selectedLevel,
    pmfilters,
    storeLoaded,
  ) {
    loading = true;
    let filterString = [];
    if (storeLoaded) {
      const applicableFilters = getApplicableFilters(pmfilters[analysisid]);
      filterString = JSON.stringify(applicableFilters);
    }
    fetchWithSession(
      `/api/analysis/AppOverviewTimeKPIs?analysisid=` +
        analysisid +
        (selectedLevel
          ? `&partitionlabel=` + applicationname
          : `&applicationname=` + applicationname) +
        `&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((dat) => {
        loading = false;
        data = dat;
        if (
          (Array.isArray(data) && data.length === 0) ||
          (typeof data === "object" &&
            (data === null || Object.keys(data).length === 0))
        ) {
          showToast = true;
        }
      });
  }
</script>

<FilterToast bind:showToast />

<Header section="Usage Analysis" breadcrumb="Workload">
  <Button
    text="To Dashboard"
    on:click={() => {
      navigate(`${ROUTES.analysis.dashboard}?analysisid=${analysisid}`);
    }}
    iconLeft={true}
    icon={ARROW_LEFT_ICON}
    kind="secondary"
  />
  <Filter />
</Header>

<SectionWrapper {fullscreen} fitScreen={true}>
  <div slot="main" class="main_wapper">
    <div class="canvas">
      <div class="ui_viewer_wrapper">
        {#if loading}
          <div class="loading_wrapper">
            <Loading withOverlay={false} />
          </div>
        {:else if casesSelected}
          {#key $pmfilters[analysisid]}
            <TimeOverview bind:this={TimeOverviewChart} {analysisid} />
          {/key}
        {:else if (data.length > 0 && Array.isArray(data)) || (typeof data === "object" && data !== null && Object.keys(data).length > 0)}
          <LineChartNeu
            bind:this={lineChart}
            height="100%"
            width="100%"
            axes={usersSelected ? ["y", "y"] : ["y1", "y", "y"]}
            dataSets={usersSelected
              ? [
                  ...(data[dailySelected ? "daily" : "hourly"]?.meanusers ||
                    []),
                  ...(data[dailySelected ? "daily" : "hourly"]?.maxusers || []),
                ]
              : [
                  ...(data[dailySelected ? "daily" : "hourly"]?.time || []),
                  ...(data[dailySelected ? "daily" : "hourly"]?.keystrokes ||
                    []),
                  ...(data[dailySelected ? "daily" : "hourly"]?.mouseclicks ||
                    []),
                ]}
          />
        {:else}
          <div class="no_data">No matching data for the applied filter</div>
        {/if}
      </div>
    </div>
    <div class="menu_overlay bottom">
      <div class="buttons_wrapper">
        <ContentSwitcher
          bind:selected={selectedLevel}
          options={["Applications", "Windows"]}
          fitContent={true}
        />
      </div>
      <div class="buttons_wrapper">
        <ContentSwitcher
          bind:selected={selectedIndex}
          options={tabOptions}
          fitContent={true}
        />
      </div>
      <div class="buttons_wrapper">
        <ContentSwitcher
          disabled={selectedIndex === 2 ? [0] : []}
          bind:selected={dailySelected}
          options={["Hourly", "Daily"]}
          fitContent={true}
        />
      </div>
      <div class="buttons_wrapper">
        <Button
          kind="secondary"
          icon={SQUARE_LANDSCAPE_ICON}
          on:click={() => {
            if (casesSelected && TimeOverviewChart)
              TimeOverviewChart.download(currentApp);
            else if (lineChart) lineChart.download(currentApp);
          }}
        />
        <Button
          kind="secondary"
          icon={fullscreen ? FULLSCREEN_OFF_ICON : FULLSCREEN_ICON}
          on:click={() => {
            fullscreen = !fullscreen;
          }}
        />
      </div>
    </div>
  </div>

  <div class="menu" slot="menu">
    <Accordion heading="App Selection" open={true}>
      <AppSelection
        appData={selectedLevel ? windowlist : applicationlist}
        bind:currentApp
        bind:selectedLevel
        windowSelectionEnabled={false}
        {loading}
      />
    </Accordion>
    <Accordion heading="App Information" open={false}>
      <AppInformation
        summary
        appData={selectedLevel ? windowlist : applicationlist}
        {currentApp}
        {loading}
      />
    </Accordion>

    <!-- <Accordion heading="Settings" open={false}>
      <div class="toggle_wrapper">
        <Toggle text="UI-Elements" bind:active={drawUIElements} />
        <Toggle text="Clusters" bind:active={drawClicks} />
        <Toggle text="Screenshot" bind:active={drawScreenshot} />
        <div class="upload_wrapper">
          <Button
            kind="secondary"
            iconLeft={true}
            enlarge={true}
            icon="upload"
            text="Upload Screenshot"
            disable={true}
          />
        </div>
      </div>
    </Accordion> -->
  </div>
</SectionWrapper>

<style>
  /* .upload_wrapper {
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px solid #d9d9d9;
  }

  .toggle_wrapper {
    display: flex;
    flex-direction: column;
  } */

  .main_wapper {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 1; /* Stellt sicher, dass das Overlay über dem Canvas liegt */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bottom {
    bottom: 0;
  }

  .canvas {
    height: calc(100% - 110px);
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .ui_viewer_wrapper {
    height: 100%;
    width: 100%;
  }

  .loading_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .no_data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-size: 2rem;
    color: var(--pax-black);
  }
</style>
